/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const GitBranchMinus = [
  ["path", { d: "M15 6a9 9 0 0 0-9 9V3" }],
  ["path", { d: "M21 18h-6" }],
  ["circle", { cx: "18", cy: "6", r: "3" }],
  ["circle", { cx: "6", cy: "18", r: "3" }]
];

export { GitBranchMinus as default };
//# sourceMappingURL=git-branch-minus.js.map
